import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { rem } from 'polished';
import theme from 'lib/theme';

// NOTE: `useDialog` is the preferred way to consume this component as it
// pre-binds open and close functions and a react portal

const Body = styled(Box)`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: calc(100% - 1.25rem);
  max-width: ${({ maxWidth }) => maxWidth || rem(660)};
  max-height: 90%;
`;

const Overlay = styled('div')`
  z-index: ${theme.zIndices.modal};
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(34, 34, 34, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Dialog = ({ children, Portal, isOpen, maxWidth, ...rest }) => {
  if (!isOpen) return null;

  return (
    <Portal>
      <Overlay>
        <Body bg="white" role="dialog" maxWidth={maxWidth} {...rest}>
          {children}
        </Body>
      </Overlay>
    </Portal>
  );
};

Dialog.propTypes = {
  Portal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node,
  px: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  py: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.string,
};

Dialog.defaultProps = {
  children: null,
  px: [4, 10],
  py: [5, 8],
  borderRadius: 'default',
  maxWidth: null,
};

export default Dialog;
